'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MessageBarBody", {
    enumerable: true,
    get: function() {
        return MessageBarBody;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useMessageBarBody = require("./useMessageBarBody");
const _renderMessageBarBody = require("./renderMessageBarBody");
const _useMessageBarBodyStylesstyles = require("./useMessageBarBodyStyles.styles");
const _useMessageBarBodyContextValues = require("./useMessageBarBodyContextValues");
const MessageBarBody = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMessageBarBody.useMessageBarBody_unstable)(props, ref);
    const ctx = (0, _useMessageBarBodyContextValues.useMessageBarBodyContextValues_unstable)(state);
    (0, _useMessageBarBodyStylesstyles.useMessageBarBodyStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMessageBarBodyStyles_unstable')(state);
    return (0, _renderMessageBarBody.renderMessageBarBody_unstable)(state, ctx);
});
MessageBarBody.displayName = 'MessageBarBody';
